// extracted by mini-css-extract-plugin
export var portfolio = "portfolio-module--portfolio--aZlYW";
export var projects_style = "portfolio-module--projects_style--MFxel";